<template>
  <wrld-container
    :breadcrumbs="this.breadcrumbs"
    :pageIsLoading="pageIsLoading"
  >
    <v-alert
      :value="(fetchOrder && fetchOrder.locked)"
      type="warning"
      class="mb-4"
    >
      {{ $t('orders.managed_by_bridge')}}
    </v-alert>
    <v-form
      ref="orderForm"
      v-model="valid"
      lazy-validation
    >
      <wrld-box :headerTitle="$t('orders.parties')" hideableContent>
        <template v-slot:boxContent>
          <v-row>
            <v-col cols="12">
              <v-alert
                type="error"
                outlined
                :value="notValidCompanies"
              >
                <!-- TODO: fill name of the company -->
                {{ $t('orders.one_has_to_be_your_company', {company: signedInCompany.name})}}
              </v-alert>
            </v-col>
            <v-col cols="12" md="6">
              <OrderFormAddress
                class="address-origin"
                v-model="order.originAddress"
                direction="origin"
                :isUpdate="isUpdate"
              />
            </v-col>
            <v-col cols="12" md="6">
              <OrderFormAddress
                v-model="order.destinationAddress"
                direction="destination"
                :isUpdate="isUpdate"
              />
            </v-col>
          </v-row>
        </template>
      </wrld-box>

      <wrld-box :headerTitle="$t('orders.transport_details')" hideableContent>
        <template v-slot:boxContent>
          <OrderFormDetails v-model="order.orderDetails" />
        </template>
      </wrld-box>

      <wrld-box :headerTitle="`${$t('orders.order_items')} (${itemsCount})`" hideableContent :hiddenContent="itemsCount > 0">
        <template v-slot:boxContent>
          <OrderFormCargo v-model="order.cargos" />
        </template>
      </wrld-box>

      <v-alert
        type="error"
        outlined
        :value="order.cargos.length === 0"
      >
        {{$t('orders.minimum_packages')}}
      </v-alert>

      <v-btn class="mr-3" @click="goBack()">{{$t('buttons.cancel')}}</v-btn>
      <v-btn @click="callUpdateOrder()">{{$t('buttons.save')}}</v-btn>
      <span v-if="!valid" class="red--text">{{$t('general.not_all_required_fields')}}</span>
    </v-form>
  </wrld-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import OrderFormAddress from '@/components/orders/OrderFormAddress.vue'
import OrderFormDetails from '@/components/orders/OrderFormDetails.vue'
import OrderFormCargo from '@/components/orders/OrderFormCargo.vue'
import axios from '@/plugins/axios-instance.js'
import { uuid } from 'vue-uuid'

export default {
  name: 'OrderUpdate',
  components: {
    OrderFormAddress,
    OrderFormDetails,
    OrderFormCargo
  },
  data () {
    return {
      valid: true,
      order: {
        originAddress: {
          company: '',
          contact_person: '',
          location: '',
          reference_number: '',
          open_from: null,
          open_to: null,
          dates: null,
          orderStatus: ''
        },
        destinationAddress: {
          company: '',
          contact_person: '',
          location: '',
          reference_number: '',
          open_from: null,
          open_to: null,
          dates: null
        },
        orderDetails: {
          specialRequirements: [],
          loadingType: 0,
          payer: '',
          reason: '',
          cargoDescription: '',
          cargoAdditionalInfo: ''
        },
        cargos: []
      },
      isUpdate: false,
      fetchedOrder: null,
      pageIsLoading: false
    }
  },
  computed: {
    ...mapState(['route', 'locations', 'orders', 'signedInCompany']),
    breadcrumbs () {
      return [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('orders.orders'), disabled: false, href: '#/orders' },
        { text: this.breadcrumbField, disabled: true }
      ]
    },
    breadcrumbField () {
      if (this.fetchedOrder == null) {
        return this.$i18n.t('buttons.create')
      } else {
        return `${this.fetchedOrder.code}: ${this.$i18n.t('buttons.edit')}`
      }
    },
    itemsCount () {
      return this.order.cargos.length
    },
    notValidCompanies () {
      // Check if one of buyer/seller is signed in company
      if (this.signedInCompany.name === undefined) {
        return false
      } else {
        return ((this.order.originAddress.company !== '' && this.order.originAddress.company !== this.signedInCompany.name) && (this.order.destinationAddress.company !== '' && this.order.destinationAddress.company !== this.signedInCompany.name))
      }
    }
  },
  methods: {
    ...mapActions({
      createOrder: 'createOrder',
      updateOrder: 'updateOrder',
      fetchLocationByID: 'fetchLocationByID',
      showSnackbar: 'showSnackbar',
      fetchLocations: 'fetchLocations'
    }),
    goBack () {
      router.push({ name: 'Orders' })
    },

    goToOrderDetail (orderReference) {
      router.push({ name: 'OrderDetail', params: { orderID: orderReference } })
    },
    checkAllValidation () {
      let validFormField = this.$refs['orderForm'].validate()
      // if (this.order.cargos.length === 0 || this.notValidCompanies || !validFormField) {
      //   this.valid = false
      // } else {
      this.valid = true
      // }
    },
    callUpdateOrder () {
      let validFormField = this.$refs['orderForm'].validate()
      this.checkAllValidation()
      // if (validFormField && this.order.cargos.length > 0 && !this.notValidCompanies) {
      if (validFormField && this.order.cargos.length > 0) {
        let transformedOrder = this.transformOrder(this.order)
        let snackMsg = ''
        let snackColor = ''
        if (this.route.params.orderID === undefined) {
          this.createOrder(transformedOrder)
          if (this.orders.error && this.orders.error !== '') {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'error'
          } else {
            snackMsg = this.$i18n.t('snackbars.order_created')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          setTimeout(this.goBack(transformedOrder.code), 4000)
        } else {
          this.updateOrder(transformedOrder)
          if (this.orders.error && this.orders.error !== '') {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'error'
          } else {
            snackMsg = this.$i18n.t('snackbars.order_updated')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          setTimeout(this.goToOrderDetail(transformedOrder.code), 4000)
        }
      }
    },
    transformOrder (order) {
      let userOrderRef = order.originAddress.reference_number
      let otherPartyOrderRef = order.destinationAddress.reference_number

      // if (order.originAddress.company === this.signedInCompany.name) {
      //   let tmp = userOrderRef
      //   userOrderRef = otherPartyOrderRef
      //   otherPartyOrderRef = tmp
      // }

      if (this.route.params.orderID !== undefined && userOrderRef === '') {
        userOrderRef = this.route.params.orderID
      } else if (userOrderRef === '') {
        userOrderRef = uuid.v1()
      }

      const orderID = userOrderRef.replace(new RegExp('/', 'g'), '%2F')

      return {
        code: orderID,
        customer_ref: otherPartyOrderRef,
        origin_id: this.getLocationID(order.originAddress.location),
        destination_id: this.getLocationID(order.destinationAddress.location),
        departure_date: this.transformDate(order.originAddress.dates),
        delivery_date: this.transformDate(order.destinationAddress.dates),
        status: order.originAddress.orderStatus,
        locked: true,
        reason: order.orderDetails.reason,
        comment: order.orderDetails.cargoAdditionalInfo,
        packages: this.transformPackages(order),
        incoterms: order.orderDetails.payer
      }
    },
    getIncoterms (order) { },
    transformDate (input) {
      let date = new Date(input)
      return date.toISOString()
    },
    getLocationID (locationName) {
      let result = Object.values(this.locations.data).filter(loc => {
        return locationName === `${loc.address.street} ${loc.address.street_number}, ${loc.address.city} ${loc.address.postal_code}, ${loc.address.country_code}`
      })
      if (result.length === 0) {
        // TODO: ??? some another flow?
        console.log('ERROR: cannot match location')
        return '963eb2a3-a0cc-44e7-9835-41e901573e83' // CLIMAX location
      }

      return result[0].id
    },
    transformPackages (order) {
      let result = []
      for (let i = 0; i < order.cargos.length; i++) {
        let pkg = order.cargos[i]
        result.push({
          weight: parseFloat(pkg.weight),
          dimensions: {
            length: parseFloat(pkg.length),
            width: parseFloat(pkg.width),
            height: parseFloat(pkg.height)
          }
        })
      }

      return result
    },
    fillDataStucture () {
      const loggedCompanyRef = 0 // TODO: changed for actual logged in company ID

      let editingOrder = this.fetchedOrder

      if (editingOrder === null) {
        return null
      }
      this.$set(editingOrder, 'origin', this.getLocationByID(editingOrder.origin_id))
      this.$set(editingOrder, 'destination', this.getLocationByID(editingOrder.destination_id))
      // order.origin = this.getLocationByID(order.origin_id)
      // order.destination = this.getLocationByID(order.destination_id)

      for (let i = 0; i < editingOrder.packages.length; i++) {
        // order.packages[i].code = order.code + '-' + i
        this.$set(editingOrder.packages[i], 'code', editingOrder.code + '-' + i)
      }
      if (editingOrder != null) {
        let tmpOrder = {
          originAddress: {
            company: editingOrder.origin.company,
            contact_person: '',
            location: `${editingOrder.origin.address.street} ${editingOrder.origin.address.street_number}, ${editingOrder.origin.address.city} ${editingOrder.origin.address.postal_code}, ${editingOrder.origin.address.country_code}`,
            // reference_number: (editingOrder.origin.company_ref == loggedCompanyRef ? editingOrder.code : editingOrder.customer_ref),
            reference_number: editingOrder.code,
            open_from: null,
            open_to: null,
            dates: new Date(editingOrder.departure_date).toISOString().substr(0, 10),
            orderStatus: editingOrder.status
          },
          destinationAddress: {
            company: editingOrder.destination.company,
            contact_person: '',
            location: `${editingOrder.destination.address.street} ${editingOrder.destination.address.street_number}, ${editingOrder.destination.address.city} ${editingOrder.destination.address.postal_code}, ${editingOrder.destination.address.country_code}`,
            reference_number: editingOrder.customer_ref,
            // reference_number: (editingOrder.destination.company_ref == loggedCompanyRef ? editingOrder.code : editingOrder.customer_ref),
            open_from: null,
            open_to: null,
            dates: new Date(editingOrder.delivery_date).toISOString().substr(0, 10)
          },
          orderDetails: {
            specialRequirements: [],
            loadingType: 0,
            payer: 'buyer',
            reason: '1',
            cargoDescription: '',
            cargoAdditionalInfo: editingOrder.comment
          },
          cargos: []
        }
        this.$set(this, 'order', tmpOrder)
        editingOrder.packages.forEach(pckg => {
          let cargo = {
            type: 'box',
            length: pckg.dimensions.length,
            width: pckg.dimensions.width,
            height: pckg.dimensions.height,
            mesurmentUnit: 'cm',
            weight: pckg.weight,
            weightUnit: 'kg',
            quantity: '1',
            stockable: pckg.stuckable
          }
          this.order.cargos.push(cargo)
        })
      }
    },
    getLocationByID (locationID) {
      let loc = this.locations.data[locationID]

      if (loc === undefined) {
        return {
          company: 'Unknow',
          company_ref: '',
          address: {
            street: '',
            street_number: '',
            country: '',
            city: '',
            postal_code: ''
          },
          coordinates: {
            lat: 0,
            lng: 0
          }
        }
      }
      return loc
    },
    async fetchOrder (orderID) {
      // TODO: move it to vuex store from here
      let param = this.replaceAll(orderID, '/', '%2F')
      let url = `https://8avugx3xy8.execute-api.eu-west-1.amazonaws.com/prod/orders/${param}`

      await axios.get(url).then(resp => {
        this.$set(this, 'fetchedOrder', resp.data)
      }).catch(error => {
        console.log(error)
      })
    },
    replaceAll (str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace)
    },
    async fetchData () {
      this.pageIsLoading = true
      let orderID = this.route.params.orderID
      await this.fetchLocations()
      // await this.fetchLocationByID(this.signedInCompany.id)

      if (orderID) {
        await this.fetchOrder(orderID)
        await this.fetchLocationByID(this.fetchedOrder.destination_id)
        await this.fetchLocationByID(this.fetchedOrder.origin_id)
        this.fillDataStucture()
        this.isUpdate = true
      }
      this.pageIsLoading = false
    }
  },
  async created () {
    await this.fetchData()
  }
}
</script>

<style scoped>
.address-origin {
  border-right: 1px solid #e2e2e2;
}
</style>
